import { Col, Layout, Row, Typography } from "antd";
import { connect, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import Header from "../../Authorized/Header";
import { getJobDetail } from "../../Redux/client/reducer";
import Feedback from "../../Utilities/Feedback";
import {
  Loading3QuartersOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import {
  StyledTag,
  StyledTitle,
  StyledText,
  StyledLink,
} from "../../styled-components/components";
import moment from "moment";
import { Helmet } from "react-helmet";

const ViewJob = (props) => {
  const [loading, setLoading] = useState(true);
  const jobId = props.match.params.jobId;
  const { getJobDetail } = props;
  const { jobDetail } = useSelector((state) => state.clientStore);
  useEffect(() => {
    const fetchJob = async () => {
      await getJobDetail(jobId);
      setLoading(false);
    };
    fetchJob();
  }, [getJobDetail, jobId]);
  const {
    title,
    typeRequirement,
    createdDate,
    additionalComments,
    attachments,
    T24Release,
  } = jobDetail;
  const createdAt = (createdDate) => {
    return moment.utc(createdDate).from(moment());
  };
  return (
    <Layout>
      <Helmet title={`${title} | Unicon`} />
      <Header />
      <Layout.Content>
        <Col>
          {loading ? (
            <Col>
              <Feedback
                icon={<Loading3QuartersOutlined spin />}
                title="Fetching the job"
              />
            </Col>
          ) : (
            <Col
              md={{ span: 11 }}
              style={{
                padding: "1vh",
                background: "#ffffff",
                border: "1px solid #f4f4f4",
                margin: "2vh",
                marginLeft: "auto",
                marginRight: "auto",
                borderRadius: "2vh",
              }}
            >
              <Col style={{ padding: "1vh" }}>
                <Row justify="space-between">
                  <Col xl={{ span: 20 }}>
                    <Row justify="space-between">
                      <Col xl={{ span: 24 }}>
                        <StyledTitle textColor="#e7315a" level={5}>
                          {title}
                        </StyledTitle>
                        <Col>
                          <ClockCircleOutlined /> {createdAt(createdDate)}
                        </Col>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row style={{ margin: "1vh" }}>
                  {additionalComments ? (
                    <Typography.Paragraph
                      ellipsis={
                        additionalComments.length > 20
                          ? {
                              rows: 1.5,
                              expandable: true,
                              symbol: (
                                <StyledText textColor="#1565d8">
                                  more
                                </StyledText>
                              ),
                            }
                          : false
                      }
                    >
                      {additionalComments}
                    </Typography.Paragraph>
                  ) : null}
                </Row>
                <Col>
                  <Row>
                    <Typography.Text>Attachments</Typography.Text>
                  </Row>
                  <Row>
                    {attachments.length > 0 ? (
                      <Col>
                        {attachments.map((file) => (
                          <StyledLink style={{ margin: "1vh" }}>
                            {file.fileName}
                          </StyledLink>
                        ))}
                      </Col>
                    ) : (
                      <Col>
                        <Typography.Text strong>
                          No Files Uploaded
                        </Typography.Text>
                      </Col>
                    )}
                  </Row>
                </Col>
                <Row justify="space-between" align="middle">
                  <Col>
                    <Row justify="space-between">
                      <Col>
                        <StyledTag>{typeRequirement}</StyledTag>
                      </Col>
                      <Col>
                        <StyledTag>{T24Release}</StyledTag>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Col>
          )}
        </Col>
      </Layout.Content>
    </Layout>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getJobDetail: (jobId) => dispatch(getJobDetail(jobId)),
  };
};

export default connect(null, mapDispatchToProps)(ViewJob);
